export const ACTIONS = {
    ADD_APPLICATION_HEADER_TITLE: 'ADD_APPLICATION_HEADER_TITLE',
    CLEAR_APPLICATION_HEADER_TITLE: 'CLEAR_APPLICATION_HEADER_TITLE',
    SET_HEADER_LOADING_STATE: 'SET_HEADER_LOADING_STATE',
    CLEAR_HEADER_LOADING_STATE: 'CLEAR_HEADER_LOADING_STATE'
};

export function addApplicationHeaderTitle(title) {
    return {
        type: ACTIONS.ADD_APPLICATION_HEADER_TITLE,
        payload: { title }
    };
}

export function clearApplicationHeaderTitle() {
    return {
        type: ACTIONS.CLEAR_APPLICATION_HEADER_TITLE,
        payload: {}
    };
}

export function setHeaderLoadingState(loadingText) {
    return {
        type: ACTIONS.SET_HEADER_LOADING_STATE,
        payload: { loadingText }
    };
}

export function clearHeaderLoadingState() {
    return {
        type: ACTIONS.CLEAR_HEADER_LOADING_STATE,
        payload: {}
    };
}
